export function askPayload(entries) {
  const allowed = new Set(['source-url','sku','source','product-title','customer-id','customer-name','customer-email','customer-phone','customer-comment']);
  const payload = {};
  for (const [key, value] of entries) {
    const match = /^contact\[([^\]]+)\]$/.exec(key);
    if (match && allowed.has(match[1])) payload[match[1]] = String(value);
  }
  if (!payload['source-url'] || !payload.sku || !['card','pdp'].includes(payload.source)) throw Error('Missing product context');
  return payload;
}
export async function submitAsk(payload, send = fetch) {
  const response = await send('https://complements.swistart.work/api/asksimilar', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:AbortSignal.timeout(15000)});
  if (!response.ok || (await response.json()).result !== 'success') throw Error('Request rejected');
}
class TbwlAsk extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.dialog = this.querySelector('dialog'); this.form = this.querySelector('form'); this.status = this.querySelector('[role="status"]');
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-tbwl-ask]'); if (!trigger) return;
      event.preventDefault(); event.stopPropagation();
      this.form.reset(); this.form.hidden = false; this.status.textContent = '';
      const context = {'source-url':new URL(trigger.dataset.url,location.origin).href,sku:trigger.dataset.sku,source:trigger.dataset.source,'product-title':trigger.dataset.title};
      for (const [key,value] of Object.entries(context)) this.form.elements.namedItem(`contact[${key}]`).value = value || '';
      this.querySelector('[data-product-title]').textContent = context['product-title'];
      this.trigger = trigger; this.dialog.showModal();
    }, {...options,capture:true});
    this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.dialog.addEventListener('close',()=>this.trigger?.focus(),options);
    this.form.addEventListener('submit',async event=>{
      event.preventDefault(); if (this.busy || !this.form.reportValidity()) return;
      const button = this.form.querySelector('[type="submit"]'); this.busy = button.disabled = true;
      try {await submitAsk(askPayload(new FormData(this.form)));this.form.hidden=true;this.status.textContent=this.status.dataset.success;}
      catch {this.status.textContent=this.status.dataset.error;}
      finally {this.busy=button.disabled=false;}
    },options);
  }
  disconnectedCallback(){this.abort?.abort();}
}
if (!customElements.get('tbwl-ask')) customElements.define('tbwl-ask', TbwlAsk);
